module.exports = "<form style=\"margin: 0;\" class=\"flexbox-container\">\n  <!-- selectedBisac: {{selectedBisac}} <br> -->\n  <app-bisac-search class=\"width-65\" required [(ngModel)]=\"selectedBisac\" name=\"selectedBisac\" (ngModelChange)=\"onBisacChange($event)\"></app-bisac-search>\n\n  <button *ngIf=\"eraseable\" mat-icon-button (click)=\"eraseMe()\">\n    <mat-icon>clear</mat-icon>\n  </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/bisac-selector/bisac-selector.component.html
// module id = ./src/app/components/book/bisac-selector/bisac-selector.component.html
// module chunks = main